module.exports = __webpack_public_path__ + "static/media/mapathon.e6aa1252.svg";